<h1>Offer Redemptions</h1>

<div class="panel panel-default">
  <div class="panel-heading"><h3 class="panel-title">Filters</h3></div>
  <div class="panel-body">
    <div class="table-nav-menu">
      <!-- <a class="pull-right" href="{{ apiUrl }}offers/redemptions/report?{{ queryString}}" download>
        <i style="float: right;" class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
      </a> -->

      <span class="pull-right" *ngIf="exportingExcel"><div style="width: 28px; height: 28px;" class="loading-spinner"></div></span>
      <a id='offerRedemptionsListingExport' *ngIf="!exportingExcel" class="pull-right" (click)="downloadReport()">
        <i style="float: right;" class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
      </a>

      <ch-daterangepicker (selected)="datepickerChanged($event)" [data]="pageParams" pastSearch="true" id="offer-redemptions-listing-period-picker"></ch-daterangepicker>
      <ch-live-search
        [items]="locations"
        [showClass]="1"
        (change)="locationChanged($event)"
        value="{{ pageParams.locationId }}"
      ></ch-live-search>
      <ch-search-input (search)="search($event)" value="{{ pageParams.search }}"></ch-search-input>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">Offer Redemptions</div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th class="sortable">
              <span class="col-name"
                >ID
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Place / Offer Title
                <ch-sortable [column]="'OFFER_ESTABLISHMENT_AND_HEADLINE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Name
                <ch-sortable [column]="'USER_NAME'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Code
                <ch-sortable [column]="'USER_CODE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Redemption Time
                <ch-sortable [column]="'REDEMPTION_TIME'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td class="col-md-3">{{ item.id }}</td>
            <td class="col-md-3">{{ item.offerEstablishmentName }}</td>
            <td class="col-md-3">{{ item.firstName + ' ' + item.lastName }}</td>
            <td class="col-md-3">{{ item.userCode }}</td>
            <td class="col-md-3">{{ item.redemptionTime | dateFormat: 'datetime' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination-dropdown
      *ngIf="!loading"
      [totalItems]="totalItems"
      [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize"
      (pageChanged)="onPageChanged($event)"
    ></ch-pagination-dropdown>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offer-redemptions/offer-redemptions-listing/offer-redemptions-listing.component.html